import { Observer } from 'rxjs';

/**
 * Suppress console errors when already logged by the LoggingInterceptor.
 */
export const noopErrorObserver: Partial<Observer<unknown>> = {
  error: () => 'no-op',
};
